import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  url = "/api/update";

  constructor(private http: HttpClient) { }

  db(): Observable<any> {
    return this.http.get<any>(this.url + "/db");
  }

}
